import { render } from "./NcrmDealBoard.vue?vue&type=template&id=7dfb5e82&scoped=true"
import script from "./NcrmDealBoard.vue?vue&type=script&lang=js"
export * from "./NcrmDealBoard.vue?vue&type=script&lang=js"

import "./NcrmDealBoard.vue?vue&type=style&index=0&id=7dfb5e82&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7dfb5e82"]])

export default __exports__